import { Button } from "@/components/ui/button"
import { SquarePen, Trash2 } from "lucide-react"
import useUserEventSideSheet from "@/modules/calendar/stores/use-user-event-side-sheet"
import useEventModal from "@/modules/calendar/stores/use-event-modal"
import isLocked from "@/modules/calendar/utils/is-locked"

interface SideSheetHeaderProps {
  isPending: boolean
}

export default function SideSheetHeader({ isPending }: SideSheetHeaderProps) {
  const { openSideSheet, isAddition, event } = useUserEventSideSheet()
  const { openEventModal } = useEventModal()

  const handleOnEditEvent = () => {
    openSideSheet({ type: "edition" })
  }

  const handleOnDeleteEvent = () => {
    openEventModal({ type: "deletion", event })
  }

  if (isLocked(event) || isAddition) return null

  return (
    <div
      className={`absolute left-0 top-0 flex w-full items-center justify-end gap-4 pr-[45px] pt-1 ${isPending ? "pointer-events-none opacity-50" : ""}`}
    >
      <Button className="bg-transparent p-0" title="Editar" onClick={handleOnEditEvent}>
        <SquarePen className="!size-5 text-gray-500" />
      </Button>

      <Button className="bg-transparent p-0" title="Eliminar" onClick={handleOnDeleteEvent}>
        <Trash2 className="!size-5 text-gray-500" />
      </Button>
    </div>
  )
}
